export default "__VITE_ASSET__Be2wGfXO__"